import { render, staticRenderFns } from "./areacodeList.vue?vue&type=template&id=698a83f9&scoped=true"
import script from "./areacodeList.vue?vue&type=script&lang=js"
export * from "./areacodeList.vue?vue&type=script&lang=js"
import style0 from "./areacodeList.vue?vue&type=style&index=0&id=698a83f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698a83f9",
  null
  
)

export default component.exports